import React from "react";
import { useChannelStateContext } from "stream-chat-react";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useUpdateChannelMetadata } from "@/components/pages/chats/component/hooks/useUpdateChannelMetadata";
import { useTranslation } from "react-i18next";

export const ResolveChatButton = () => {
  const { t } = useTranslation();
  const { channel } = useChannelStateContext();
  const { updateMetadata } = useUpdateChannelMetadata();

  const isResolved = !!channel?.data?.resolved;

  const toggleResolved = async () => {
    await updateMetadata({
      resolved: !isResolved,
    });
  };

  return (
    <Button
      variant="outline"
      onClick={toggleResolved}
      className={cn(
        "h-full px-3 gap-2 transition-all shadow-sm border-slate-200",
        "bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-800",
        isResolved && "border-green-200 bg-green-50/30 text-slate-800",
      )}
    >
      <span className="font-medium">
        {isResolved ? t("chats.resolved") : t("chats.resolveConversation")}
      </span>
      <CheckCircle2
        className={cn(
          "w-4 h-4 transition-colors",
          isResolved ? "text-green-600" : "text-slate-500",
        )}
      />
    </Button>
  );
};
